import {clear, fromNumber, handleKeyPress} from 'ui/keyboard';
import {ADD_SYMBOL, HANDLE_COMMAND, CREATE_FROM_NUMBER, UPDATE_MODE} from './actions';
import {CLOSE_SETTINGS} from '../UI/actions';

export function userInput(state: UserInputState, {type, payload}: Action): UserInputState {
  switch (type) {
    case ADD_SYMBOL:
    case HANDLE_COMMAND:
      return {
        ...state,
        keyboard: handleKeyPress(state.keyboard, payload),
      };

    case CREATE_FROM_NUMBER:
      return {
        ...state,
        keyboard: fromNumber(payload),
      };

    case CLOSE_SETTINGS:
      return {
        ...state,
        keyboard: clear(),
      };

    case UPDATE_MODE:
      return {
        ...state,
        inputMode: payload,
      };

    default:
      return state;
  }
}
